import React, { Suspense, useEffect, useState } from 'react'
import { HashRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import './scss/style.scss'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const AppRoutes = () => {
  const location = useLocation()

  const checkLogin = () => {
    const token = localStorage.getItem('token')

    if (!token) return false

    try {
      const decoded = jwtDecode(token)

      if (decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem('token')
        return false
      }

      return true
    } catch {
      localStorage.removeItem('token')
      return false
    }
  }

  const [isLoggedIn, setIsLoggedIn] = useState(checkLogin())

  useEffect(() => {
    setIsLoggedIn(checkLogin())
  }, [location.pathname])

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isLoggedIn ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Login setIsLoggedIn={setIsLoggedIn} />
          )
        }
      />

      <Route path="*" element={isLoggedIn ? <DefaultLayout /> : <Navigate to="/login" replace />} />
    </Routes>
  )
}

const App = () => (
  <HashRouter>
    <Suspense fallback={loading}>
      <AppRoutes />
    </Suspense>
  </HashRouter>
)

export default App
